export default "__VITE_ASSET__kT2eOIuW__"